import type { FunctionComponent, SuspenseProps } from "react";
import React, { useEffect, useState } from "react";

/**
 * This component will render the suspense in CSR for handling suspense boundary issue
 */
export const ClientSideSuspense: FunctionComponent<SuspenseProps> = ({ children, ...props }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(true);
  }, []);

  return show ? <React.Suspense {...props}>{children}</React.Suspense> : props.fallback;
};

ClientSideSuspense.displayName = "ClientSideSuspense";
